import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { LayoutGrid, Search, Plus, FileText, X } from 'lucide-react';

interface SidebarProps {
  onCloseSidebar?: () => void;
}

interface SidebarItem {
  name: string;
  path: string;
  icon: React.ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ onCloseSidebar }) => {
  const { user } = useAuth();
  const location = useLocation();
  
  const navItems: SidebarItem[] = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: <LayoutGrid className="w-5 h-5" />,
    },
    {
      name: 'All Searches',
      path: '/searches',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
        </svg>
      ),
    },
    {
      name: 'New Search',
      path: '/searches/region',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
        </svg>
      ),
    },
  ];
  
  // Add admin items if user is admin
  console.log('Sidebar user:', user);
  if (user?.is_admin) {
    navItems.push({
      name: 'Admin',
      path: '/admin',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9zm3 1a1 1 0 00-.707.293L10 4.586 9.707 4.293A1 1 0 009 4v.585l1.707 1.707a1 1 0 001.586 0L14 4.585V4a1 1 0 00-1-1h-1z" clipRule="evenodd" />
        </svg>
      ),
    });
  }
  
  return (
    <aside className="w-64 bg-white border-r border-gray-200 h-full">
      <div className="h-full px-3 py-4 overflow-y-auto">
        <div className="flex items-center justify-between mb-4 md:hidden">
          <span className="text-lg font-semibold text-gray-800">Menu</span>
          {onCloseSidebar && (
            <button 
              onClick={onCloseSidebar}
              className="p-1 rounded-md text-gray-400 hover:text-primary hover:bg-gray-100"
            >
              <X className="h-6 w-6" />
            </button>
          )}
        </div>
        
        <ul className="space-y-2">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center p-2 text-base font-normal rounded-lg ${
                  location.pathname === item.path
                    ? 'bg-primary/10 text-primary'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                onClick={onCloseSidebar}
              >
                <span className="mr-3">{item.icon}</span>
                <span>{item.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar; 